var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/// <reference lib="dom" />
import { normalizeUrl } from '@sisense/sdk-common';
import { BaseAuthenticator } from './base-authenticator.js';
import { appendHeaders } from './helpers.js';
import { errorInterceptor } from './interceptors.js';
export class PasswordAuthenticator extends BaseAuthenticator {
    constructor(url, user, pass) {
        super('password');
        this._authheader = '';
        this.url = `${normalizeUrl(url)}api/v1/authentication/login`;
        const username = encodeURIComponent(user);
        const password = encodeURIComponent(pass);
        this.body = `username=${username}&password=${password}`;
    }
    authenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._tried) {
                return this._result;
            }
            this._tried = true;
            try {
                this._authenticating = true;
                const response = yield fetch(this.url, {
                    method: 'POST',
                    headers: {
                        accept: 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: this.body,
                }).catch(errorInterceptor);
                if (response.ok) {
                    const json = yield response.json();
                    this._authheader = json.access_token;
                }
            }
            finally {
                this._resolve(!!this._authheader);
                this._authenticating = false;
            }
            return this._result;
        });
    }
    applyHeaders(headers) {
        const authHeader = 'Bearer ' + this._authheader;
        appendHeaders(headers, { Authorization: authHeader });
    }
}
/**
 * Checks if an authenticator is a PasswordAuthenticator.
 *
 * @param authenticator - the authenticator to check
 * @internal
 */
export function isPasswordAuthenticator(authenticator) {
    return authenticator.type === 'password';
}
//# sourceMappingURL=password-authenticator.js.map